// @flow

import React from 'react'
import StandardContactForm from '@/components/Forms/StandardContactForm'

type Props = {
  action: String,
}

export default ({ action }: Props) => (
  <StandardContactForm
    name="15 Craigside Guide Request"
    action={action}
    submitLabel="Get the Brochures"
  />
)
